const ITEMS = ["AI", "QUANTUM", "SEMICONDUCTORS", "TECHNOLOGY", "REAL-WORLD UTILITY", "SOLANA", "KINGBULLISH", "$KBULL"];

export const Marquee = () => {
  const row = (key) =>
    ITEMS.map((item, i) => (
      <span key={`${key}-${i}`} className="marquee__item">
        <span className="marquee__dot" />
        {item}
      </span>
    ));
  return (
    <div className="marquee relative z-10" aria-hidden="true" data-testid="hero-marquee">
      <div className="marquee__track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
